export let imageSlideCount = 0;

export function populateBannerCarousel(jsonData){

    var currentSlideCount = 1;

    $(".carousel-count-heading").html("SHOWING " + currentSlideCount + "/" + jsonData.header.data.images.length);

    function getMainSlide(){
        var mainSlide = $('.slides.main.prototype.hidden').clone().removeClass('prototype hidden');
        mainSlide.addClass("mainSlide")
        return {
            element: mainSlide,
            image: mainSlide.find('img.editableImage'),
        }
    }

    function getNavSlide(){
        var navSlide = $('.slides.nav.prototype.hidden').clone().removeClass('prototype hidden');
        navSlide.addClass("navSlide")
        return {
            element: navSlide,
            image: navSlide.find('img'),
        }
    }


    function populateData(jsonData){        
        $.each(jsonData.header.data.images, function(index, item) {
            if(imageSlideCount<jsonData.header.data.maximum){ 
                var newMainSlide = getMainSlide();

                

                // newMainSlide.image.attr('src', item.path);
                newMainSlide.image.attr('data-src', item.path);

                if(item.path.indexOf('_cropped')> -1){
                    newMainSlide.image.attr('data-original-src', item.path.split('_cropped')[0] + '.jpg');

                    if($(window).width() < 768){
                        newMainSlide.image.attr('src', item.path.split('_cropped')[0] + '_cropped2.jpg');    
                    }
                    else{
                        newMainSlide.image.attr('src', item.path);   
                    }
                }
                else{
                    newMainSlide.image.attr('data-original-src', item.path);
                    newMainSlide.image.attr('src', item.path);
                }

                newMainSlide.image.attr('slide-count', imageSlideCount + 1);
                $('.slider.slider-single').slick('slickAdd', newMainSlide.element);

                var newNavSlide = getNavSlide();
                newNavSlide.image.attr('src', item.path);
                newNavSlide.image.attr('slide-count', imageSlideCount + 1);

                if($(document).find(".preview").hasClass("hidden") && index > 0){
                    newNavSlide.element.find(".removeImage").removeClass("hidden");
                }
                else if($(document).find(".preview").hasClass("hidden") && index == 0){
                    newNavSlide.element.css("margin-top", "28px");
                }


                $('.slider.slider-nav').slick('slickAdd', newNavSlide.element);

                imageSlideCount++;   
            }
        });
    }

    function addDynamicImageSlide(){
        var newMainSlide = getMainSlide();
        newMainSlide.image.attr('slide-count', imageSlideCount + 1);
        $('.slider.slider-single').slick('slickAdd', newMainSlide.element);
     
        // Go to added slide
        var goToSingleSlide = newMainSlide.element.attr('data-slick-index');        
        $('.slider-single').slick('slickGoTo', goToSingleSlide);

        var newNavSlide = getNavSlide();
        newNavSlide.image.attr('slide-count', imageSlideCount + 1);
        newNavSlide.element.find(".removeImage").removeClass("hidden");
        $('.slider.slider-nav').slick('slickAdd', newNavSlide.element);
    }

    $(".addBannerCarouselImage").on('click', function(){        
        if(imageSlideCount<jsonData.header.data.maximum){
            addDynamicImageSlide();
            imageSlideCount++;                     
        }
        else{
            toastNotify(3,"You have acheived the maximum limit.");
        }
    });   

    $(".slider.slider-nav").on('click', ".removeImage" ,function(e){    
        e.stopPropagation()      
        var slideCount = $(this).parent().find(".carouselNav").attr("slide-count");
        
        $(".slider.slider-single").find(".bannerCarouselImage[slide-count="+slideCount+"]").parent().remove();
        
        $(this).parent().remove();

        imageSlideCount--;   

        $(".slider.slider-single").find('.slick-arrow').remove();
        $('.slider.slider-single').slick('reinit');
        $('.slider.slider-nav').slick('reinit');

        $('.mainSlide').each(function(index){
            $(this).attr("data-slick-index", index)
        })

        $('.navSlide').each(function(index){
            $(this).attr("data-slick-index", index)
        })

        var currentActiveSlide = $('.slider.slider-single').find(".slides.main.slick-current").attr("data-slick-index");
        
        $(".carousel-count-heading").html("SHOWING " + (parseInt(currentActiveSlide) + 1) + "/" + imageSlideCount);
    });

    populateData(jsonData);
}